import { type FC } from "react";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "react-bootstrap";

import { SimpleTable, type SimpleTableHeader } from "../../../table";

export interface ServiceIdRow {
  inquiryId: string;
  serviceId: string;
  service: string;
  subservice: string;
  subjectOrTest: string;
}

interface ServiceIdAccordionProps {
  rows: ServiceIdRow[];
  onSelectServiceId?: (inquiryId: string) => void;
}

export const ServiceIdAccordion: FC<ServiceIdAccordionProps> = ({ rows, onSelectServiceId }) => {
  const headers: SimpleTableHeader<ServiceIdRow>[] = [
    {
      renderKey: "serviceId",
      name: "Service ID",
      render: row => {
        if (!onSelectServiceId) {
          return row.serviceId;
        }

        return (
          <a
            href={`/inquiry/${row.inquiryId}`}
            onClick={event => {
              event.preventDefault();
              onSelectServiceId(row.inquiryId);
            }}
          >
            {row.serviceId}
          </a>
        );
      },
      tableDataCellProps: {
        isPrimary: true
      }
    },
    {
      key: "service",
      name: "Service"
    },
    {
      key: "subservice",
      name: "Subservice"
    },
    {
      key: "subjectOrTest",
      name: "Subject/Test"
    }
  ];

  return (
    <Accordion className="mb-4">
      <AccordionItem eventKey="0">
        <AccordionHeader as="h3">Service ID</AccordionHeader>
        <AccordionBody>
          <SimpleTable tableCollapseScreenSize="sm" headers={headers} data={rows} uniqueIdKey="inquiryId" />
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
};
